<template>
  <div class="t-login-service-ended">
    <div class="t-login-service-ended__content">
      <div class="t-login-service-ended__content-logo">
        <img src="@/images/cotoha-call-center-logo-horizontal.svg" height="100" />
      </div>
      <div class="t-login-service-ended__content-text">
        <h3>COTOHA Call Centerのご提供は、2025年3月31日をもちまして終了しました。</h3>
      </div>
      <div class="t-login-service-ended__content-graphic">
        <img src="@/images/pages/login-graphic.svg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 't-login-service-ended',
};
</script>
